import Guard from 'arg-guard'

/**
 * Defined structure of a building part.
 *
 * @export
 * @class BuildingPart
 */
export default class BuildingPart {

    /**
     *Creates an instance of BuildingPart.
     * @param {number} index The part index.
     * @param {Array} data The items data for the building part.
     * @memberof BuildingPart
     */
    constructor(index, data) {
        Guard.throwIf(index, 'index')
        Guard.throwIf(data, 'items')

        this.index = index
        this.name = `Building Part ${ index }`
        this.data = data
    }
}
